webpackJsonp([12],{

/***/ 414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverriddenSurcharge_vue__ = __webpack_require__(733);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f87159de_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverriddenSurcharge_vue__ = __webpack_require__(977);
function injectStyle (ssrContext) {
  __webpack_require__(960)
}
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f87159de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverriddenSurcharge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f87159de_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverriddenSurcharge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(462));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    cancel: function cancel() {
      $("#deletemodal").modal("hide");
      this.$emit("cancel");
    },
    submit: function submit() {
      $("#deletemodal").modal("hide");
      this.$emit("submit");
    }
  }
});

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(461));

var _alphaNum = _interopRequireDefault(__webpack_require__(464));

var _numeric = _interopRequireDefault(__webpack_require__(465));

var _between = _interopRequireDefault(__webpack_require__(466));

var _email = _interopRequireDefault(__webpack_require__(467));

var _ipAddress = _interopRequireDefault(__webpack_require__(468));

var _macAddress = _interopRequireDefault(__webpack_require__(469));

var _maxLength = _interopRequireDefault(__webpack_require__(470));

var _minLength = _interopRequireDefault(__webpack_require__(471));

var _required = _interopRequireDefault(__webpack_require__(472));

var _requiredIf = _interopRequireDefault(__webpack_require__(473));

var _requiredUnless = _interopRequireDefault(__webpack_require__(474));

var _sameAs = _interopRequireDefault(__webpack_require__(475));

var _url = _interopRequireDefault(__webpack_require__(476));

var _or = _interopRequireDefault(__webpack_require__(477));

var _and = _interopRequireDefault(__webpack_require__(478));

var _not = _interopRequireDefault(__webpack_require__(479));

var _minValue = _interopRequireDefault(__webpack_require__(480));

var _maxValue = _interopRequireDefault(__webpack_require__(481));

var _integer = _interopRequireDefault(__webpack_require__(482));

var _decimal = _interopRequireDefault(__webpack_require__(483));

var helpers = _interopRequireWildcard(__webpack_require__(458));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","BRAND_NAME":"Trransfer","VUE_APP_GOOGLE_MAPS_KEY":"AIzaSyDwoOCBqFXIhPMWg922paZIpeVZkudwH6I","VUE_APP_BASE_API":"https://prod-gateway-opsicar.idteknologia.net","VUE_APP_AUTH_HOST":"https://authservice.trransfer.com","VUE_APP_CDN":"https://maverick-global-assets.s3-ap-southeast-1.amazonaws.com","VUE_APP_GOOGLE_TAG_ID":"UA-171512499-1","VUE_APP_SUPPORT_WIDGET_ID":"51000003059","VUE_APP_SUPPORT_WIDGET_SOURCE":"https://aus-widget.freshworks.com/widgets/51000003059.js"}).BUILD === 'web' ? __webpack_require__(463).withParams : __webpack_require__(230).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.withParams)({
  type: 'required'
}, function (value) {
  if (typeof value === 'string') {
    return (0, _common.req)(value.trim());
  }

  return (0, _common.req)(value);
});

exports.default = _default;

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);

exports.default = _default;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__ = __webpack_require__(459);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_003a6066_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__ = __webpack_require__(485);
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_003a6066_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"role":"dialog","id":"deletemodal"}},[_c('div',{staticClass:"modal-dialog modal-xs"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body modal-confirmation"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-wrapper"},[_vm._m(0),_vm._v(" "),_c('header',[_vm._v("Are you sure?")]),_vm._v(" "),_c('p',[_vm._v("\n                Do you want to delete this record? This process cannot be\n                undone.\n              ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v("\n                  Cancel\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"submit"},on:{"click":_vm.submit}},[_vm._v("\n                  Yes, delete\n                ")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-icon"},[_c('i',{staticClass:"ic-close"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/master/peakPeriods";

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/list").then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllByFilter: function getAllByFilter(month, year, search) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/list/filter?month=" + month + "&year=" + year + "&search=" + search)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getAllById: function getAllById(id) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/list/" + id)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  create: function create(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  update: function update(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt("return", _context5.sent);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  delete: function _delete(id) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ("/" + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),

/***/ 733:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_master_buyingTariff_OverriddenGeneralSurcharge__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_master_buyingTariff_OverriddenCancellationSurcharge__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_master_buyingTariff_OverriddenPeakPeriodSurcharge__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_master_buyingTariff_OverriddenWaitingTimeSurcharge__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_master_buyingTariff_buyingTariffOverriddenSurchargeService_js__ = __webpack_require__(976);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    generalSurcharge: __WEBPACK_IMPORTED_MODULE_2__components_master_buyingTariff_OverriddenGeneralSurcharge__["a" /* default */],
    cancellationSurcharge: __WEBPACK_IMPORTED_MODULE_3__components_master_buyingTariff_OverriddenCancellationSurcharge__["a" /* default */],
    peakPeriodSurcharge: __WEBPACK_IMPORTED_MODULE_4__components_master_buyingTariff_OverriddenPeakPeriodSurcharge__["a" /* default */],
    waitingTimeSurcharge: __WEBPACK_IMPORTED_MODULE_5__components_master_buyingTariff_OverriddenWaitingTimeSurcharge__["a" /* default */]
  },
  computed: {
    isServicesExist: function isServicesExist() {
      return this.allServices && this.allServices !== null;
    },
    isAllowToRead: function isAllowToRead() {
      return this.isServicesExist && (this.allServices["BuyingTariffOverriddenGeneralSurcharge"] || this.allServices["BuyingTariffOverriddenCancellationSurcharge"] || this.allServices["BuyingTariffOverriddenPeakPeriodSurcharge"] || this.allServices["BuyingTariffOverriddenWaitingTimeSurcharge"]);
    },
    isAllowToManageGeneralSurcharge: function isAllowToManageGeneralSurcharge() {
      return this.isServicesExist && this.allServices["BuyingTariffOverriddenGeneralSurcharge"].includes("Read");
    },
    isAllowToManageCancellationSurcharge: function isAllowToManageCancellationSurcharge() {
      return this.isServicesExist && this.allServices["BuyingTariffOverriddenCancellationSurcharge"].includes("Read");
    },
    isAllowToManagePeakPeriodSurcharge: function isAllowToManagePeakPeriodSurcharge() {
      return this.isServicesExist && this.allServices["BuyingTariffOverriddenPeakPeriodSurcharge"].includes("Read");
    },
    isAllowToManageWaitingTimeSurcharge: function isAllowToManageWaitingTimeSurcharge() {
      return this.isServicesExist && this.allServices["BuyingTariffOverriddenWaitingTimeSurcharge"].includes("Read");
    },
    recordInfo: function recordInfo() {
      return this.table.totalRecords > 1 ? this.table.totalRecords + " Records" : this.table.totalRecords + " Record";
    }
  },
  data: function data() {
    return {
      validationErrors: {},
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100]
      },
      allServices: null,
      items: [],
      isLoading: false,
      msg: "Please wait"
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings, profile;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();
              _context.next = 3;
              return _this.$store.dispatch("setting/getAllPublic");

            case 3:
              publicSettings = _context.sent;

              _this.table.pageSize = _this.$helper.extractSetting(publicSettings, "PageSize", 25);

              _context.next = 7;
              return _this.$store.dispatch("user/getProfile");

            case 7:
              profile = _context.sent;

              _this.allServices = profile.services;

              if (!_this.isAllowToRead) {
                _context.next = 12;
                break;
              }

              _context.next = 12;
              return _this.getAll();

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  updated: function updated() {
    this.$helper.collapseMenu("buying-tariff");
    this.$helper.setNavigationClass("overridden-buying-surcharge-link");
  },

  methods: {
    onChangePageSize: function onChangePageSize() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.table.pageNumber = 1;
                _context2.next = 3;
                return _this2.getAll();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onKeyupKeyword: function onKeyupKeyword() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var self;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = _this3;

                if (self.timer) {
                  clearTimeout(self.timer);
                  self.timer = null;
                }
                self.timer = setTimeout(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            self.table.pageNumber = 1;
                            _context3.next = 3;
                            return self.getAll();

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }(), 500);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    onNavigateCallback: function onNavigateCallback(pageNumber) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.table.pageNumber = pageNumber;
                _context5.next = 3;
                return _this4.getAll();

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    getAll: function getAll() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var filter, response, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this5.isLoading = true;
                filter = "?page=" + _this5.table.pageNumber + "&size=" + _this5.table.pageSize;

                if (_this5.table.keyword !== null && _this5.table.keyword !== "") {
                  filter += "&search=" + _this5.table.keyword;
                }
                _context6.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_buyingTariff_buyingTariffOverriddenSurchargeService_js__["a" /* default */].getAll(filter);

              case 6:
                response = _context6.sent;

                _this5.items = response.data;
                _this5.table.totalPages = response.totalPages;
                _this5.table.totalRecords = response.totalRecords;
                _context6.next = 15;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6["catch"](0);

                if (_context6.t0.errors) {
                  for (index = 0; index < _context6.t0.errors.length; index++) {
                    _this5.$notification.error(_context6.t0.errors[index], { title: "Error" });
                  }
                }

              case 15:
                _context6.prev = 15;

                _this5.isLoading = false;
                return _context6.finish(15);

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this5, [[0, 12, 15, 18]]);
      }))();
    },
    manageGeneralSurcharge: function manageGeneralSurcharge(item) {
      // publish message
      this.$eventBus.$emit("initializeBuyingTariffOverriddenGeneralSurcharge", item);
    },
    manageCancellationSurcharge: function manageCancellationSurcharge(item) {
      // publish message
      this.$eventBus.$emit("initializeBuyingTariffOverriddenCancellationSurcharge", item);
    },
    managePeakPeriodSurcharge: function managePeakPeriodSurcharge(item) {
      // publish message
      this.$eventBus.$emit("initializeBuyingTariffOverriddenPeakPeriodSurcharge", item);
    },
    manageWaitingTimeSurcharge: function manageWaitingTimeSurcharge(item) {
      // publish message
      this.$eventBus.$emit("initializeBuyingTariffOverriddenWaitingTimeSurcharge", item);
    }
  }
});

/***/ }),

/***/ 734:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_DeleteModal__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_master_buyingTariff_buyingTariffOverriddenGeneralSurchargeService_js__ = __webpack_require__(965);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    deleteModal: __WEBPACK_IMPORTED_MODULE_2__components_shared_DeleteModal__["a" /* default */]
  },
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    }
  },
  data: function data() {
    return {
      isOpen: false,
      weekends: [],
      model: {
        nightTimeSurchargeStart: "19:00",
        nightTimeSurchargeEnd: "06:59"
      },
      activeTab: "nighttime",
      allPermissions: [],
      formatter: null,
      moneyFormat: null,
      selectedPolicy: null,
      isUpdate: false,
      itemToBeDeleted: null,
      items: [],
      isLoading: false,
      msg: "Please wait"
    };
  },
  created: function created() {
    this.$eventBus.$on("initializeBuyingTariffOverriddenGeneralSurcharge", this.initialize);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("initializeBuyingTariffOverriddenGeneralSurcharge");
  },

  methods: {
    initialize: function initialize(policy) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var profile, permissions;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.isLoading = true;
                _this.isOpen = true;
                _this.selectedPolicy = policy;
                _this.moneyFormat = policy.moneyFormat;
                _this.formatter = new Intl.NumberFormat(policy.moneyFormat.cultureCode, {
                  style: "currency",
                  currency: policy.moneyFormat.currencyCode,
                  currencyDisplay: "code",
                  minimumFractionDigits: policy.moneyFormat.numberOfDecimal
                });

                _this.activeTab = "nighttime";
                _this.reset();

                _context.next = 10;
                return _this.$store.dispatch("user/getProfile");

              case 10:
                profile = _context.sent;
                permissions = profile.services["BuyingTariffOverriddenGeneralSurcharge"];

                if (permissions) {
                  _this.allPermissions = permissions;
                }

                if (!_this.isAllowToRead) {
                  _context.next = 17;
                  break;
                }

                _this.weekends = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
                _context.next = 17;
                return _this.getAll();

              case 17:

                _this.openModal();

              case 18:
                _context.prev = 18;

                _this.isLoading = false;
                return _context.finish(18);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0,, 18, 21]]);
      }))();
    },
    resetModel: function resetModel() {
      this.activeTab = "nighttime";
      this.model = {};
    },
    openModal: function openModal(object) {
      $(this.$refs.vuemodal).modal({ backdrop: "static", keyboard: false });
    },
    closeModal: function closeModal() {
      this.resetModel();
      $(this.$refs.vuemodal).modal("hide");
      this.isOpen = false;
    },
    reset: function reset() {
      this.isUpdate = false;
      this.model = {};
    },
    getAll: function getAll() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.isLoading = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3__services_master_buyingTariff_buyingTariffOverriddenGeneralSurchargeService_js__["a" /* default */].getAll(_this2.selectedPolicy.policyId);

              case 4:
                _this2.model = _context2.sent;

                if (_this2.model === null) {
                  _this2.isUpdate = false;
                  _this2.model = { isActive: true };
                } else {
                  _this2.isUpdate = true;
                }
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                if (_context2.t0.errors) {
                  for (index = 0; index < _context2.t0.errors.length; index++) {
                    _this2.$notification.error(_context2.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context2.prev = 11;

                _this2.isLoading = false;
                return _context2.finish(11);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8, 11, 14]]);
      }))();
    },
    resolveProperty: function resolveProperty() {
      if (this.model.garageTimeFixedRate) {
        this.model.garageTimeFixedRate = parseFloat(this.model.garageTimeFixedRate);
      }

      if (this.model.garageTimeBandMinimum) {
        this.model.garageTimeBandMinimum = parseFloat(this.model.garageTimeBandMinimum);
      }

      if (this.model.garageTimeBandMinutes) {
        this.model.garageTimeBandMinutes = parseFloat(this.model.garageTimeBandMinutes);
      }

      if (this.model.minimumHourlyHire) {
        this.model.minimumHourlyHire = parseInt(this.model.minimumHourlyHire);
      }

      if (this.model.minuteRoundingTime) {
        this.model.minuteRoundingTime = parseInt(this.model.minuteRoundingTime);
      }

      if (this.model.nightTimeSurchargeStart && this.model.nightTimeSurchargeStart !== "" && this.model.nightTimeSurchargeEnd && this.model.nightTimeSurchargeEnd !== "") {
        if (this.model.nightTimeSurchargePercentage && this.model.nightTimeSurchargePercentage !== "") {
          this.model.nightTimeSurchargePercentage = parseFloat(this.model.nightTimeSurchargePercentage);
        } else {
          this.model.nightTimeSurchargePercentage = null;
        }

        if (this.model.nightTimeSurchargeFlatRate && this.model.nightTimeSurchargeFlatRate !== "") {
          this.model.nightTimeSurchargeFlatRate = parseFloat(this.model.nightTimeSurchargeFlatRate);
        } else {
          this.model.nightTimeSurchargeFlatRate = null;
        }

        if (this.model.nightTimeSurchargeHourlyRate && this.model.nightTimeSurchargeHourlyRate !== "") {
          this.model.nightTimeSurchargeHourlyRate = parseFloat(this.model.nightTimeSurchargeHourlyRate);
        } else {
          this.model.nightTimeSurchargeHourlyRate = null;
        }
      } else {
        delete this.model.nightTimeSurchargeStart;
        delete this.model.nightTimeSurchargeEnd;
        delete this.model.nightTimeSurchargePercentage;
        delete this.model.nightTimeSurchargeFlatRate;
        delete this.model.nightTimeSurchargeHourlyRate;
      }

      if (this.model.weekendSurchargeDays && this.model.weekendSurchargeDays.length > 0) {
        if (this.model.weekendSurchargeFlatRate && this.model.weekendSurchargeFlatRate !== "") {
          this.model.weekendSurchargeFlatRate = parseFloat(this.model.weekendSurchargeFlatRate);
        } else {
          this.model.weekendSurchargeFlatRate = null;
        }

        if (this.model.weekendSurchargeHourlyRate && this.model.weekendSurchargeHourlyRate !== "") {
          this.model.weekendSurchargeHourlyRate = parseFloat(this.model.weekendSurchargeHourlyRate);
        } else {
          this.model.weekendSurchargeHourlyRate = null;
        }

        if (this.model.weekendSurchargePercentage && this.model.weekendSurchargePercentage !== "") {
          this.model.weekendSurchargePercentage = parseFloat(this.model.weekendSurchargePercentage);
        } else {
          this.model.weekendSurchargePercentage = null;
        }
      } else {
        delete this.model.weekendSurchargeDays;
        delete this.model.weekendSurchargeFlatRate;
        delete this.model.weekendSurchargeHourlyRate;
        delete this.model.weekendSurchargePercentage;
      }
    },
    createItem: function createItem() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this3.isLoading = true;
                _this3.model.policyId = _this3.selectedPolicy.policyId;
                _this3.resolveProperty();
                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3__services_master_buyingTariff_buyingTariffOverriddenGeneralSurchargeService_js__["a" /* default */].create(_this3.model);

              case 6:
                _this3.$notification.success("Successfully added.", { title: "Success" });
                _this3.closeModal();
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);

                if (_context3.t0.errors) {
                  for (index = 0; index < _context3.t0.errors.length; index++) {
                    _this3.$notification.error(_context3.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
                _context3.prev = 13;

                _this3.isLoading = false;
                return _context3.finish(13);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 10, 13, 16]]);
      }))();
    },
    updateItem: function updateItem(item) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this4.isLoading = true;
                _this4.model.policyId = _this4.selectedPolicy.policyId;
                _this4.resolveProperty();
                _context4.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3__services_master_buyingTariff_buyingTariffOverriddenGeneralSurchargeService_js__["a" /* default */].update(_this4.model);

              case 6:
                _this4.$notification.success("Successfully updated.", { title: "Success" });
                _this4.closeModal();
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);

                if (_context4.t0.errors) {
                  for (index = 0; index < _context4.t0.errors.length; index++) {
                    _this4.$notification.error(_context4.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
                _context4.prev = 13;

                _this4.isLoading = false;
                return _context4.finish(13);

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 10, 13, 16]]);
      }))();
    },
    confirmDelete: function confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    submitDelete: function submitDelete() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this5.isLoading = true;
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3__services_master_buyingTariff_buyingTariffOverriddenGeneralSurchargeService_js__["a" /* default */].delete(_this5.itemToBeDeleted);

              case 4:
                _this5.$notification.success("Successfully deleted.", { title: "Success" });
                _this5.isItemHasBeenModified = true;
                _this5.closeModal();
                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](0);

                if (_context5.t0.errors) {
                  for (index = 0; index < _context5.t0.errors.length; index++) {
                    _this5.$notification.error(_context5.t0.errors[index], { title: "Error" });
                  }
                }

              case 12:
                _context5.prev = 12;

                _this5.isLoading = false;
                return _context5.finish(12);

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 9, 12, 15]]);
      }))();
    }
  }
});

/***/ }),

/***/ 735:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_master_buyingTariff_buyingTariffOverriddenCancellationSurchargeService_js__ = __webpack_require__(968);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    deleteModal: __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__["a" /* default */]
  },
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    }
  },
  data: function data() {
    return {
      isSubmitted: false,
      isOpen: false,
      allPermissions: [],
      selectedPolicy: null,
      formatter: null,
      moneyFormat: null,
      itemToBeDeleted: null,
      items: [],
      model: {},
      isUpdate: false,
      isLoading: false,
      msg: "Please wait"
    };
  },
  validations: function validations() {
    return {
      model: {
        totalHourBeforePickup: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(0) },
        percentageCharge: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(0) }
      }
    };
  },
  created: function created() {
    this.$eventBus.$on("initializeBuyingTariffOverriddenCancellationSurcharge", this.initialize);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("initializeBuyingTariffOverriddenCancellationSurcharge");
  },

  methods: {
    initialize: function initialize(policy) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var profile, permissions;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.isLoading = true;
                _this.isOpen = true;
                _this.selectedPolicy = policy;
                _this.moneyFormat = policy.moneyFormat;
                _this.formatter = new Intl.NumberFormat(policy.moneyFormat.cultureCode, {
                  style: "currency",
                  currency: policy.moneyFormat.currencyCode,
                  currencyDisplay: "code",
                  minimumFractionDigits: policy.moneyFormat.numberOfDecimal
                });
                _this.reset();

                _context.next = 9;
                return _this.$store.dispatch("user/getProfile");

              case 9:
                profile = _context.sent;
                permissions = profile.services["BuyingTariffOverriddenCancellationSurcharge"];

                if (permissions) {
                  _this.allPermissions = permissions;
                }

                if (!_this.isAllowToRead) {
                  _context.next = 15;
                  break;
                }

                _context.next = 15;
                return _this.getAll();

              case 15:

                _this.openModal();

              case 16:
                _context.prev = 16;

                _this.isLoading = false;
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0,, 16, 19]]);
      }))();
    },
    openModal: function openModal() {
      $(this.$refs.vuemodal).modal({
        backdrop: "static",
        keyboard: false
      });
    },
    closeModal: function closeModal() {
      $(this.$refs.vuemodal).modal("hide");
      this.isOpen = false;
    },
    resetValidation: function resetValidation() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    bindModel: function bindModel(object) {
      this.isUpdate = true;
      this.resetValidation();
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, object);
    },
    reset: function reset() {
      this.isUpdate = false;
      this.resetValidation();
      this.model = {};
    },
    getAll: function getAll() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_buyingTariff_buyingTariffOverriddenCancellationSurchargeService_js__["a" /* default */].getAll(_this2.selectedPolicy.policyId);

              case 2:
                _this2.items = _context2.sent;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    fixNumber: function fixNumber() {
      this.model.totalHourBeforePickup = parseInt(this.model.totalHourBeforePickup);
      this.model.percentageCharge = parseFloat(this.model.percentageCharge);
    },
    submit: function submit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.isSubmitted = true;
                _this3.$v.model.$touch();

                if (!_this3.$v.model.$error) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return");

              case 4:
                _context3.prev = 4;

                _this3.isLoading = true;
                _this3.model.policyId = _this3.selectedPolicy.policyId;
                _this3.fixNumber();

                if (_this3.isUpdate) {
                  _context3.next = 14;
                  break;
                }

                _context3.next = 11;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_buyingTariff_buyingTariffOverriddenCancellationSurchargeService_js__["a" /* default */].create(_this3.model);

              case 11:
                _this3.$notification.success("Successfully added.", { title: "Success" });
                _context3.next = 17;
                break;

              case 14:
                _context3.next = 16;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_buyingTariff_buyingTariffOverriddenCancellationSurchargeService_js__["a" /* default */].update(_this3.model);

              case 16:
                _this3.$notification.success("Successfully updated.", { title: "Success" });

              case 17:
                _this3.reset();
                _context3.next = 20;
                return _this3.getAll();

              case 20:
                _context3.next = 25;
                break;

              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3["catch"](4);

                if (_context3.t0.errors) {
                  for (index = 0; index < _context3.t0.errors.length; index++) {
                    _this3.$notification.error(_context3.t0.errors[index], { title: "Error" });
                  }
                }

              case 25:
                _context3.prev = 25;

                _this3.isLoading = false;
                return _context3.finish(25);

              case 28:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[4, 22, 25, 28]]);
      }))();
    },
    changeStatus: function changeStatus(item) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this4.isLoading = true;
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_buyingTariff_buyingTariffOverriddenCancellationSurchargeService_js__["a" /* default */].update(item);

              case 4:
                _this4.$notification.success("Successfully updated.", { title: "Success" });
                _this4.reset();
                _context4.next = 8;
                return _this4.getAll();

              case 8:
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);

                if (_context4.t0.errors) {
                  for (index = 0; index < _context4.t0.errors.length; index++) {
                    _this4.$notification.error(_context4.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
                _context4.prev = 13;

                _this4.isLoading = false;
                return _context4.finish(13);

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 10, 13, 16]]);
      }))();
    },
    confirmDelete: function confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    submitDelete: function submitDelete() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this5.isLoading = true;
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_buyingTariff_buyingTariffOverriddenCancellationSurchargeService_js__["a" /* default */].delete(_this5.itemToBeDeleted);

              case 4:
                _this5.$notification.success("Successfully deleted.", { title: "Success" });
                _this5.isItemHasBeenModified = true;
                _context5.next = 8;
                return _this5.getAll();

              case 8:
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](0);

                if (_context5.t0.errors) {
                  for (index = 0; index < _context5.t0.errors.length; index++) {
                    _this5.$notification.error(_context5.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
                _context5.prev = 13;

                _this5.isLoading = false;
                return _context5.finish(13);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 10, 13, 16]]);
      }))();
    }
  }
});

/***/ }),

/***/ 736:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_master_peakPeriod_peakPeriodService_js__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_master_buyingTariff_buyingTariffOverriddenPeakPeriodSurchargeService_js__ = __webpack_require__(971);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    deleteModal: __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__["a" /* default */]
  },
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    }
  },
  data: function data() {
    return {
      isSubmitted: false,
      isOpen: false,
      allPermissions: [],
      formatter: null,
      moneyFormat: null,
      selectedPolicy: null,
      peakPeriods: [],
      items: [],
      model: {},
      isUpdate: false,
      isLoading: false,
      msg: "Please wait"
    };
  },
  validations: function validations() {
    return {
      model: {
        peakPeriodId: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        flatRate: { minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(0) },
        hourlyRate: { minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(0) },
        percentageCharge: { minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(0) }
      }
    };
  },
  created: function created() {
    this.$eventBus.$on("initializeBuyingTariffOverriddenPeakPeriodSurcharge", this.initialize);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("initializeBuyingTariffOverriddenPeakPeriodSurcharge");
  },

  methods: {
    initialize: function initialize(policy) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var profile, permissions;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.isLoading = true;
                _this.isOpen = true;
                _this.selectedPolicy = policy;
                _this.moneyFormat = policy.moneyFormat;
                _this.formatter = new Intl.NumberFormat(policy.moneyFormat.cultureCode, {
                  style: "currency",
                  currency: policy.moneyFormat.currencyCode,
                  currencyDisplay: "code",
                  minimumFractionDigits: policy.moneyFormat.numberOfDecimal
                });
                _this.reset();

                _context.next = 9;
                return _this.$store.dispatch("user/getProfile");

              case 9:
                profile = _context.sent;
                permissions = profile.services["BuyingTariffOverriddenPeakPeriodSurcharge"];

                if (permissions) {
                  _this.allPermissions = permissions;
                }

                if (!_this.isAllowToRead) {
                  _context.next = 16;
                  break;
                }

                _context.next = 15;
                return _this.getAll();

              case 15:
                _this.getPeakPeriods();

              case 16:

                _this.openModal();

              case 17:
                _context.prev = 17;

                _this.isLoading = false;
                return _context.finish(17);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0,, 17, 20]]);
      }))();
    },
    openModal: function openModal() {
      $(this.$refs.vuemodal).modal({
        backdrop: "static",
        keyboard: false
      });
    },
    closeModal: function closeModal() {
      $(this.$refs.vuemodal).modal("hide");
      this.isOpen = false;
    },
    resetValidation: function resetValidation() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    bindModel: function bindModel(object) {
      this.isUpdate = true;
      this.resetValidation();
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, object);
    },
    reset: function reset() {
      this.isUpdate = false;
      this.resetValidation();
      this.model = {};
    },
    getAll: function getAll() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_buyingTariff_buyingTariffOverriddenPeakPeriodSurchargeService_js__["a" /* default */].getAll(_this2.selectedPolicy.policyId);

              case 2:
                _this2.items = _context2.sent;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getPeakPeriods: function getPeakPeriods() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_peakPeriod_peakPeriodService_js__["a" /* default */].getAllByProviderId(_this3.selectedPolicy.providerId);

              case 2:
                _this3.peakPeriods = _context3.sent;

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    fixNumber: function fixNumber() {
      this.model.flatRate = parseFloat(this.model.flatRate);
      this.model.hourlyRate = parseFloat(this.model.hourlyRate);
      this.model.percentageCharge = parseFloat(this.model.percentageCharge);
    },
    printTotalDaysLabel: function printTotalDaysLabel(totalDays) {
      return totalDays <= 1 ? totalDays + " day" : totalDays + " days";
    },
    submit: function submit() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.isSubmitted = true;
                _this4.$v.model.$touch();

                if (!_this4.$v.model.$error) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return");

              case 4:
                _context4.prev = 4;

                _this4.isLoading = true;
                _this4.model.policyId = _this4.selectedPolicy.policyId;
                _this4.fixNumber();

                if (_this4.isUpdate) {
                  _context4.next = 14;
                  break;
                }

                _context4.next = 11;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_buyingTariff_buyingTariffOverriddenPeakPeriodSurchargeService_js__["a" /* default */].create(_this4.model);

              case 11:
                _this4.$notification.success("Successfully added.", { title: "Success" });
                _context4.next = 17;
                break;

              case 14:
                _context4.next = 16;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_buyingTariff_buyingTariffOverriddenPeakPeriodSurchargeService_js__["a" /* default */].update(_this4.model);

              case 16:
                _this4.$notification.success("Successfully updated.", { title: "Success" });

              case 17:
                _this4.reset();
                _context4.next = 20;
                return _this4.getAll();

              case 20:
                _context4.next = 25;
                break;

              case 22:
                _context4.prev = 22;
                _context4.t0 = _context4["catch"](4);

                if (_context4.t0.errors) {
                  for (index = 0; index < _context4.t0.errors.length; index++) {
                    _this4.$notification.error(_context4.t0.errors[index], { title: "Error" });
                  }
                }

              case 25:
                _context4.prev = 25;

                _this4.isLoading = false;
                return _context4.finish(25);

              case 28:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[4, 22, 25, 28]]);
      }))();
    },
    changeStatus: function changeStatus(item) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this5.isLoading = true;
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_buyingTariff_buyingTariffOverriddenPeakPeriodSurchargeService_js__["a" /* default */].update(item);

              case 4:
                _this5.$notification.success("Successfully updated.", { title: "Success" });
                _this5.reset();
                _context5.next = 8;
                return _this5.getAll();

              case 8:
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](0);

                if (_context5.t0.errors) {
                  for (index = 0; index < _context5.t0.errors.length; index++) {
                    _this5.$notification.error(_context5.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
                _context5.prev = 13;

                _this5.isLoading = false;
                return _context5.finish(13);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 10, 13, 16]]);
      }))();
    },
    confirmDelete: function confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    submitDelete: function submitDelete() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this6.isLoading = true;
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_buyingTariff_buyingTariffOverriddenPeakPeriodSurchargeService_js__["a" /* default */].delete(_this6.itemToBeDeleted);

              case 4:
                _this6.$notification.success("Successfully deleted.", { title: "Success" });
                _this6.isItemHasBeenModified = true;
                _context6.next = 8;
                return _this6.getAll();

              case 8:
                _context6.next = 13;
                break;

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6["catch"](0);

                if (_context6.t0.errors) {
                  for (index = 0; index < _context6.t0.errors.length; index++) {
                    _this6.$notification.error(_context6.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
                _context6.prev = 13;

                _this6.isLoading = false;
                return _context6.finish(13);

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 10, 13, 16]]);
      }))();
    },
    printMoney: function printMoney(value) {
      return this.formatter !== null ? this.formatter.format(value).replace(/[a-z]{3}/i, "").trim() : value;
    }
  }
});

/***/ }),

/***/ 737:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_master_buyingTariff_buyingTariffOverriddenWaitingTimeSurchargeService_js__ = __webpack_require__(974);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    deleteModal: __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__["a" /* default */]
  },
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    }
  },
  data: function data() {
    return {
      isSubmitted: false,
      isOpen: false,
      rentalLabel: null,
      allPermissions: [],
      formatter: null,
      moneyFormat: null,
      selectedPolicy: null,
      itemToBeDeleted: null,
      sourceTypes: [],
      items: [],
      model: {},
      isUpdate: false,
      isLoading: false,
      msg: "Please wait"
    };
  },
  validations: function validations() {
    return {
      model: {
        type: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        totalMinuteAllowed: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(0) },
        rate: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(0) }
      }
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch("setting/getAllPublic");

            case 2:
              publicSettings = _context.sent;

              _this.rentalLabel = _this.$helper.extractSetting(publicSettings, "RentalLabel", "Hourly");

              _this.$eventBus.$on("initializeBuyingTariffOverriddenWaitingTimeSurcharge", _this.initialize);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("initializeBuyingTariffOverriddenWaitingTimeSurcharge");
  },

  methods: {
    initialize: function initialize(policy) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var profile, permissions;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.isLoading = true;
                _this2.isOpen = true;
                _this2.selectedPolicy = policy;
                _this2.moneyFormat = policy.moneyFormat;
                _this2.formatter = new Intl.NumberFormat(policy.moneyFormat.cultureCode, {
                  style: "currency",
                  currency: policy.moneyFormat.currencyCode,
                  currencyDisplay: "code",
                  minimumFractionDigits: policy.moneyFormat.numberOfDecimal
                });
                _this2.reset();
                _this2.sourceTypes = [{ text: "Airport Transfer (Arrival)", value: "ArrivalAirportTransfer" }, {
                  text: "Airport Transfer (Departure)",
                  value: "DepartureAirportTransfer"
                }, { text: "In-Town Transfer", value: "InTownTransfer" }, {
                  text: _this2.rentalLabel,
                  value: "Rental"
                }];

                _context2.next = 10;
                return _this2.$store.dispatch("user/getProfile");

              case 10:
                profile = _context2.sent;
                permissions = profile.services["BuyingTariffOverriddenWaitingTimeSurcharge"];

                if (permissions) {
                  _this2.allPermissions = permissions;
                }

                if (!_this2.isAllowToRead) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 16;
                return _this2.getAll();

              case 16:

                _this2.openModal();

              case 17:
                _context2.prev = 17;

                _this2.isLoading = false;
                return _context2.finish(17);

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0,, 17, 20]]);
      }))();
    },
    openModal: function openModal() {
      $(this.$refs.vuemodal).modal({
        backdrop: "static",
        keyboard: false
      });
    },
    closeModal: function closeModal() {
      $(this.$refs.vuemodal).modal("hide");
      this.isOpen = false;
    },
    resetValidation: function resetValidation() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    bindModel: function bindModel(object) {
      this.isUpdate = true;
      this.resetValidation();
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, object);
    },
    reset: function reset() {
      this.isUpdate = false;
      this.resetValidation();
      this.model = {};
    },
    getAll: function getAll() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_buyingTariff_buyingTariffOverriddenWaitingTimeSurchargeService_js__["a" /* default */].getAll(_this3.selectedPolicy.policyId);

              case 2:
                _this3.items = _context3.sent;

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    fixNumber: function fixNumber() {
      this.model.totalMinuteAllowed = parseInt(this.model.totalMinuteAllowed);
      this.model.rate = parseFloat(this.model.rate);
    },
    submit: function submit() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.isSubmitted = true;
                _this4.$v.model.$touch();

                if (!_this4.$v.model.$error) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return");

              case 4:
                _context4.prev = 4;

                _this4.isLoading = true;
                _this4.model.policyId = _this4.selectedPolicy.policyId;
                _this4.fixNumber();

                if (_this4.isUpdate) {
                  _context4.next = 14;
                  break;
                }

                _context4.next = 11;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_buyingTariff_buyingTariffOverriddenWaitingTimeSurchargeService_js__["a" /* default */].create(_this4.model);

              case 11:
                _this4.$notification.success("Successfully added.", { title: "Success" });
                _context4.next = 17;
                break;

              case 14:
                _context4.next = 16;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_buyingTariff_buyingTariffOverriddenWaitingTimeSurchargeService_js__["a" /* default */].update(_this4.model);

              case 16:
                _this4.$notification.success("Successfully updated.", { title: "Success" });

              case 17:
                _this4.reset();
                _context4.next = 20;
                return _this4.getAll();

              case 20:
                _context4.next = 25;
                break;

              case 22:
                _context4.prev = 22;
                _context4.t0 = _context4["catch"](4);

                if (_context4.t0.errors) {
                  for (index = 0; index < _context4.t0.errors.length; index++) {
                    _this4.$notification.error(_context4.t0.errors[index], { title: "Error" });
                  }
                }

              case 25:
                _context4.prev = 25;

                _this4.isLoading = false;
                return _context4.finish(25);

              case 28:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[4, 22, 25, 28]]);
      }))();
    },
    changeStatus: function changeStatus(item) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this5.isLoading = true;
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_buyingTariff_buyingTariffOverriddenWaitingTimeSurchargeService_js__["a" /* default */].update(item);

              case 4:
                _this5.$notification.success("Successfully updated.", { title: "Success" });
                _this5.reset();
                _context5.next = 8;
                return _this5.getAll();

              case 8:
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](0);

                if (_context5.t0.errors) {
                  for (index = 0; index < _context5.t0.errors.length; index++) {
                    _this5.$notification.error(_context5.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
                _context5.prev = 13;

                _this5.isLoading = false;
                return _context5.finish(13);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 10, 13, 16]]);
      }))();
    },
    confirmDelete: function confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    submitDelete: function submitDelete() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this6.isLoading = true;
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_buyingTariff_buyingTariffOverriddenWaitingTimeSurchargeService_js__["a" /* default */].delete(_this6.itemToBeDeleted);

              case 4:
                _this6.$notification.success("Successfully deleted.", { title: "Success" });
                _this6.isItemHasBeenModified = true;
                _context6.next = 8;
                return _this6.getAll();

              case 8:
                _context6.next = 13;
                break;

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6["catch"](0);

                if (_context6.t0.errors) {
                  for (index = 0; index < _context6.t0.errors.length; index++) {
                    _this6.$notification.error(_context6.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
                _context6.prev = 13;

                _this6.isLoading = false;
                return _context6.finish(13);

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 10, 13, 16]]);
      }))();
    },
    printMoney: function printMoney(value) {
      return this.formatter !== null ? this.formatter.format(value).replace(/[a-z]{3}/i, "").trim() : value;
    },
    humanize: function humanize(value) {
      return this.$helper.humanize(value);
    }
  }
});

/***/ }),

/***/ 960:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(961);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(372)("2b652dfe", content, true, {});

/***/ }),

/***/ 961:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(371)(true);
// imports


// module
exports.push([module.i, ".detail-row td[data-v-f87159de]{height:55px}", "", {"version":3,"sources":["/app/src/components/master/buyingTariff/OverriddenSurcharge.vue"],"names":[],"mappings":"AACA,gCACE,WAAa,CACd","file":"OverriddenSurcharge.vue","sourcesContent":["\n.detail-row td[data-v-f87159de] {\n  height: 55px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 962:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverriddenGeneralSurcharge_vue__ = __webpack_require__(734);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f38d084_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverriddenGeneralSurcharge_vue__ = __webpack_require__(966);
function injectStyle (ssrContext) {
  __webpack_require__(963)
}
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverriddenGeneralSurcharge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f38d084_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverriddenGeneralSurcharge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 963:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(964);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(372)("452c874e", content, true, {});

/***/ }),

/***/ 964:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(371)(true);
// imports


// module
exports.push([module.i, ".header-picker{display:none!important}", "", {"version":3,"sources":["/app/src/components/master/buyingTariff/OverriddenGeneralSurcharge.vue"],"names":[],"mappings":"AACA,eACE,sBAAyB,CAC1B","file":"OverriddenGeneralSurcharge.vue","sourcesContent":["\n.header-picker {\n  display: none !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 965:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/buying/override/GeneralSurcharges';

/* harmony default export */ __webpack_exports__["a"] = ({
	getAll: function getAll(policyId) {
		var _this = this;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.next = 2;
							return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/item/' + policyId)).then(function (response) {
								return response.data.data;
							}).catch(function (error) {
								throw error.response.data;
							});

						case 2:
							return _context.abrupt('return', _context.sent);

						case 3:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this);
		}))();
	},
	create: function create(request) {
		var _this2 = this;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_context2.next = 2;
							return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
								return response.data;
							}).catch(function (error) {
								throw error.response.data;
							});

						case 2:
							return _context2.abrupt('return', _context2.sent);

						case 3:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, _this2);
		}))();
	},
	update: function update(request) {
		var _this3 = this;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							_context3.next = 2;
							return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
								return response.data;
							}).catch(function (error) {
								throw error.response.data;
							});

						case 2:
							return _context3.abrupt('return', _context3.sent);

						case 3:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, _this3);
		}))();
	},
	delete: function _delete(id) {
		var _this4 = this;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
				while (1) {
					switch (_context4.prev = _context4.next) {
						case 0:
							_context4.next = 2;
							return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
								return response.data;
							}).catch(function (error) {
								throw error.response.data;
							});

						case 2:
							return _context4.abrupt('return', _context4.sent);

						case 3:
						case 'end':
							return _context4.stop();
					}
				}
			}, _callee4, _this4);
		}))();
	}
});

/***/ }),

/***/ 966:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedPolicy && _vm.isOpen)?_c('div',[_c('div',{ref:"vuemodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-new",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("General Surcharge ("+_vm._s(_vm.selectedPolicy.policyTitle)+")")]),_vm._v(" "),_c('h6',[_vm._v("\n                Last Updated: "+_vm._s(_vm.model.modifiedDate ? _vm.model.modifiedDate.stringFullDate : '-')+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.closeModal()}}},[_c('i',{staticClass:"ic-close"})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[_c('ul',{staticClass:"nav nav-tabs nav-justified tabs-mini-form"},[_c('li',{class:[_vm.activeTab === 'nighttime' ? 'active' : '']},[_c('a',{attrs:{"href":"#night-surcharge","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'nighttime'}}},[_vm._v("Night")])]),_vm._v(" "),_c('li',{class:[_vm.activeTab === 'weekend' ? 'active' : '']},[_c('a',{attrs:{"href":"#weekend-surcharge","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'weekend'}}},[_vm._v("Weekend")])]),_vm._v(" "),_c('li',{class:[_vm.activeTab === 'garage' ? 'active' : '']},[_c('a',{attrs:{"href":"#garage-surcharge","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'garage'}}},[_vm._v("Garage")])]),_vm._v(" "),_c('li',{class:[_vm.activeTab === 'others' ? 'active' : '']},[_c('a',{attrs:{"href":"#others","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'others'}}},[_vm._v("Others")])])]),_vm._v(" "),_c('form',{attrs:{"role":"form","action":"#","id":"vueform"}},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'nighttime' ? 'in active' : ''],attrs:{"id":"night-surcharge"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Start Time")]),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"nightTimeSurchargeStart","color":"#025BC5","format":"HH:mm","formatted":"HH:mm","label":"Select time","only-time":"","no-label":"","no-button":""},model:{value:(_vm.model.nightTimeSurchargeStart),callback:function ($$v) {_vm.$set(_vm.model, "nightTimeSurchargeStart", $$v)},expression:"model.nightTimeSurchargeStart"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("End Time")]),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"nightTimeSurchargeEnd","color":"#025BC5","format":"HH:mm","formatted":"HH:mm","label":"Select time","only-time":"","no-label":"","no-button":""},model:{value:(_vm.model.nightTimeSurchargeEnd),callback:function ($$v) {_vm.$set(_vm.model, "nightTimeSurchargeEnd", $$v)},expression:"model.nightTimeSurchargeEnd"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n                              Flat Rate\n                              "),(_vm.moneyFormat)?_c('span',{staticClass:"--grey50"},[_vm._v("("+_vm._s(_vm.moneyFormat.currencyCode)+")")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"label-desc"},[_vm._v(" For airport transfer ")]),_vm._v(" "),_c('currency-input',{staticClass:"form-control",attrs:{"name":"nightTimeSurchargeFlatRate","autocomplete":"off","placeholder":"Enter rate","allow-negative":false,"currency":null,"locale":_vm.moneyFormat.cultureCode,"precision":_vm.moneyFormat.numberOfDecimal},model:{value:(_vm.model.nightTimeSurchargeFlatRate),callback:function ($$v) {_vm.$set(_vm.model, "nightTimeSurchargeFlatRate", $$v)},expression:"model.nightTimeSurchargeFlatRate"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n                              Hourly Rate\n                              "),(_vm.moneyFormat)?_c('span',{staticClass:"--grey50"},[_vm._v("("+_vm._s(_vm.moneyFormat.currencyCode)+")\n                              ")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"label-desc"},[_vm._v(" For hourly hire ")]),_vm._v(" "),_c('currency-input',{staticClass:"form-control",attrs:{"name":"nightTimeSurchargeHourlyRate","autocomplete":"off","placeholder":"Enter rate","allow-negative":false,"currency":null,"locale":_vm.moneyFormat.cultureCode,"precision":_vm.moneyFormat.numberOfDecimal},model:{value:(_vm.model.nightTimeSurchargeHourlyRate),callback:function ($$v) {_vm.$set(_vm.model, "nightTimeSurchargeHourlyRate", $$v)},expression:"model.nightTimeSurchargeHourlyRate"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Percentage Charge")]),_vm._v(" "),_c('span',{staticClass:"label-desc"},[_vm._v("\n                              If flat rate/hourly rate is not exist then calculation\n                              will use percentage\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.nightTimeSurchargePercentage),expression:"model.nightTimeSurchargePercentage"}],staticClass:"form-control",attrs:{"type":"number","name":"nightTimeSurchargePercentage","min":"0","step":"any"},domProps:{"value":(_vm.model.nightTimeSurchargePercentage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nightTimeSurchargePercentage", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'weekend' ? 'in active' : ''],attrs:{"id":"weekend-surcharge"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n                              Flat Rate\n                              "),(_vm.moneyFormat)?_c('span',{staticClass:"--grey50"},[_vm._v("("+_vm._s(_vm.moneyFormat.currencyCode)+")")]):_vm._e()]),_vm._v(" "),_c('currency-input',{staticClass:"form-control",attrs:{"name":"weekendSurchargeFlatRate","autocomplete":"off","placeholder":"Enter rate","allow-negative":false,"currency":null,"locale":_vm.moneyFormat.cultureCode,"precision":_vm.moneyFormat.numberOfDecimal},model:{value:(_vm.model.weekendSurchargeFlatRate),callback:function ($$v) {_vm.$set(_vm.model, "weekendSurchargeFlatRate", $$v)},expression:"model.weekendSurchargeFlatRate"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n                              Hourly Rate\n                              "),(_vm.moneyFormat)?_c('span',{staticClass:"--grey50"},[_vm._v("("+_vm._s(_vm.moneyFormat.currencyCode)+")")]):_vm._e()]),_vm._v(" "),_c('currency-input',{staticClass:"form-control",attrs:{"name":"weekendSurchargeHourlyRate","autocomplete":"off","placeholder":"Enter rate","allow-negative":false,"currency":null,"locale":_vm.moneyFormat.cultureCode,"precision":_vm.moneyFormat.numberOfDecimal},model:{value:(_vm.model.weekendSurchargeHourlyRate),callback:function ($$v) {_vm.$set(_vm.model, "weekendSurchargeHourlyRate", $$v)},expression:"model.weekendSurchargeHourlyRate"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Percentage Charge")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.weekendSurchargePercentage),expression:"model.weekendSurchargePercentage"}],staticClass:"form-control",attrs:{"type":"number","name":"weekendSurchargePercentage","min":"0","step":"any"},domProps:{"value":(_vm.model.weekendSurchargePercentage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "weekendSurchargePercentage", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Days")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.weekends,"multiple":true,"close-on-select":false,"placeholder":"Select day","label":"","track-by":""},model:{value:(_vm.model.weekendSurchargeDays),callback:function ($$v) {_vm.$set(_vm.model, "weekendSurchargeDays", $$v)},expression:"model.weekendSurchargeDays"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'garage' ? 'in active' : ''],attrs:{"id":"garage-surcharge"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n                              Fixed Rate\n                              "),(_vm.moneyFormat)?_c('span',{staticClass:"--grey50"},[_vm._v("\n                                ("+_vm._s(_vm.moneyFormat.currencyCode)+")\n                              ")]):_vm._e()]),_vm._v(" "),_c('currency-input',{staticClass:"form-control",attrs:{"name":"garageTimeFixedRate","autocomplete":"off","placeholder":"Enter rate","allow-negative":false,"currency":null,"locale":_vm.moneyFormat.cultureCode,"precision":_vm.moneyFormat.numberOfDecimal},model:{value:(_vm.model.garageTimeFixedRate),callback:function ($$v) {_vm.$set(_vm.model, "garageTimeFixedRate", $$v)},expression:"model.garageTimeFixedRate"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Duration Band (minute)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.garageTimeBandMinutes),expression:"model.garageTimeBandMinutes"}],staticClass:"form-control",attrs:{"type":"number","name":"garageTimeBandMinutes","min":"0"},domProps:{"value":(_vm.model.garageTimeBandMinutes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "garageTimeBandMinutes", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Minimum Band")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.garageTimeBandMinimum),expression:"model.garageTimeBandMinimum"}],staticClass:"form-control",attrs:{"type":"number","name":"garageTimeBandMinimum","min":"0"},domProps:{"value":(_vm.model.garageTimeBandMinimum)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "garageTimeBandMinimum", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'others' ? 'in active' : ''],attrs:{"id":"others"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Minimum Hire (hour)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.minimumHourlyHire),expression:"model.minimumHourlyHire"}],staticClass:"form-control",attrs:{"type":"number","name":"minimumHourlyHire","min":"0"},domProps:{"value":(_vm.model.minimumHourlyHire)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "minimumHourlyHire", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Rounding Time (minute)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.minuteRoundingTime),expression:"model.minuteRoundingTime"}],staticClass:"form-control",attrs:{"type":"number","name":"minuteRoundingTime","min":"0"},domProps:{"value":(_vm.model.minuteRoundingTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "minuteRoundingTime", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Remark")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.remark),expression:"model.remark"}],staticClass:"form-control",attrs:{"rows":"3","name":"remark"},domProps:{"value":(_vm.model.remark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "remark", $event.target.value)}}})])])])])]),_vm._v(" "),(_vm.isAllowToCreate || _vm.isAllowToUpdate)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.closeModal()}}},[_vm._v("\n                      Cancel\n                    ")]),_vm._v(" "),(!_vm.isUpdate && _vm.isAllowToCreate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.createItem()}}},[_vm._v("\n                      Create\n                    ")]):_vm._e(),_vm._v(" "),(_vm.isUpdate && _vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.updateItem()}}},[_vm._v("\n                      Update\n                    ")]):_vm._e(),_vm._v(" "),(_vm.isUpdate && _vm.isAllowToDelete)?_c('button',{staticClass:"btn btn-default sts-danger",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.confirmDelete(_vm.selectedPolicy.policyId)}}},[_vm._v("\n                      Delete\n                    ")]):_vm._e()]):_vm._e()])])])])])])])]),_vm._v(" "),_c('deleteModal',{on:{"submit":_vm.submitDelete}}),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 967:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverriddenCancellationSurcharge_vue__ = __webpack_require__(735);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42681fc6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverriddenCancellationSurcharge_vue__ = __webpack_require__(969);
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverriddenCancellationSurcharge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42681fc6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverriddenCancellationSurcharge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 968:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/buying/override/CancellationSurcharges';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(policyId) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list/' + policyId)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  create: function create(request) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  update: function update(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  delete: function _delete(id) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 969:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedPolicy && _vm.isOpen)?_c('div',[_c('div',{ref:"vuemodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-new",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Cancellation Policy ("+_vm._s(_vm.selectedPolicy.policyTitle)+")")]),_vm._v(" "),_c('h6',[_vm._v("\n                Last Updated: "+_vm._s(_vm.model.modifiedDate ? _vm.model.modifiedDate.stringFullDate : '-')+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.closeModal()}}},[_c('i',{staticClass:"ic-close"})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper modal-detail"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[(_vm.$v.model.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                  This form has errors\n                ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 divider-right pr-25"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Time Before Trip (hour)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.totalHourBeforePickup),expression:"model.totalHourBeforePickup"}],staticClass:"form-control",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.totalHourBeforePickup.$error,
                          },attrs:{"type":"number"},domProps:{"value":(_vm.model.totalHourBeforePickup)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "totalHourBeforePickup", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.totalHourBeforePickup.$error)?_c('div',[(!_vm.$v.model.totalHourBeforePickup.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Rate is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.totalHourBeforePickup.minValue)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Min hour is\n                            "+_vm._s(_vm.$v.model.totalHourBeforePickup.$params.minValue.min))]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.percentageCharge),expression:"model.percentageCharge"}],staticClass:"form-control",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.percentageCharge.$error,
                          },attrs:{"type":"number","placeholder":"Number","step":"any"},domProps:{"value":(_vm.model.percentageCharge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "percentageCharge", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.percentageCharge.$error)?_c('div',[(!_vm.$v.model.percentageCharge.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Rate is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.percentageCharge.minValue)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Min percentage is\n                            "+_vm._s(_vm.$v.model.percentageCharge.$params.minValue.min))]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.isAllowToCreate || _vm.isAllowToUpdate)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.reset()}}},[_vm._v("\n                          Reset\n                        ")]),_vm._v(" "),(!_vm.isUpdate && _vm.isAllowToCreate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                          Create\n                        ")]):_vm._e(),_vm._v(" "),(_vm.isUpdate && _vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                          Update\n                        ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 divider-left pl-20"},[_c('div',{staticClass:"table-modal-detail"},[_c('div',{staticClass:"table-responsive table-accordion"},[_c('table',{staticClass:"table table-hover"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{key:item.id},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.totalHourBeforePickup))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(item.percentageCharge))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isActive),expression:"item.isActive"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":!_vm.isAllowToUpdate},domProps:{"checked":Array.isArray(item.isActive)?_vm._i(item.isActive,null)>-1:(item.isActive)},on:{"change":[function($event){var $$a=item.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isActive", $$c)}},function($event){return _vm.changeStatus(item)}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                                      "+_vm._s(item.isActive ? "Active" : "Inactive")+"\n                                    ")])])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(_vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.bindModel(item)}}},[_c('span',[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToDelete)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id)}}},[_c('i',{staticClass:"ic-close"})]):_vm._e()])])])}),0)])])])])])])])])])])])])]),_vm._v(" "),_c('deleteModal',{on:{"submit":_vm.submitDelete}}),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"required"},[_vm._v("\n                          Charge Amount "),_c('span',{staticClass:"--grey50"},[_vm._v("(%)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"number"},[_vm._v("No")]),_vm._v(" "),_c('th',[_vm._v("Time (hour)")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Charge (%)")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 970:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverriddenPeakPeriodSurcharge_vue__ = __webpack_require__(736);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55c8b894_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverriddenPeakPeriodSurcharge_vue__ = __webpack_require__(972);
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverriddenPeakPeriodSurcharge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55c8b894_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverriddenPeakPeriodSurcharge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 971:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/buying/override/PeakPeriodSurcharges';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(policyId) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list/' + policyId)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  create: function create(request) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  update: function update(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  delete: function _delete(id) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 972:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedPolicy && _vm.isOpen)?_c('div',[_c('div',{ref:"vuemodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-new",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Peak Period ("+_vm._s(_vm.selectedPolicy.policyTitle)+")")]),_vm._v(" "),_c('h6',[_vm._v("\n                Last Updated: "+_vm._s(_vm.model.modifiedDate ? _vm.model.modifiedDate.stringFullDate : '-')+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.closeModal()}}},[_c('i',{staticClass:"ic-close"})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper modal-detail"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[(_vm.$v.model.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                  This form has errors\n                ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 divider-right pr-25"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Peak Period")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                            'field-error': _vm.isSubmitted && _vm.$v.model.peakPeriodId.$error,
                          },attrs:{"placeholder":"","label":"title","options":_vm.peakPeriods,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; }},model:{value:(_vm.model.peakPeriodId),callback:function ($$v) {_vm.$set(_vm.model, "peakPeriodId", $$v)},expression:"model.peakPeriodId"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.peakPeriodId.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Peak Period is required")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n                          Flat Rate\n                          "),(_vm.moneyFormat)?_c('span',{staticClass:"--grey50"},[_vm._v("("+_vm._s(_vm.moneyFormat.currencyCode)+")")]):_vm._e()]),_vm._v(" "),_c('currency-input',{staticClass:"form-control",class:{
                            'field-error': _vm.isSubmitted && _vm.$v.model.flatRate.$error,
                          },attrs:{"autocomplete":"off","placeholder":"Enter rate","allow-negative":false,"currency":null,"locale":_vm.moneyFormat.cultureCode,"precision":_vm.moneyFormat.numberOfDecimal},model:{value:(_vm.model.flatRate),callback:function ($$v) {_vm.$set(_vm.model, "flatRate", $$v)},expression:"model.flatRate"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.flatRate.minValue)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Min flat rate is 0")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n                          Hourly Rate\n                          "),(_vm.moneyFormat)?_c('span',{staticClass:"--grey50"},[_vm._v("("+_vm._s(_vm.moneyFormat.currencyCode)+")")]):_vm._e()]),_vm._v(" "),_c('currency-input',{staticClass:"form-control",class:{
                            'field-error': _vm.isSubmitted && _vm.$v.model.hourlyRate.$error,
                          },attrs:{"autocomplete":"off","placeholder":"Enter rate","allow-negative":false,"currency":null,"locale":_vm.moneyFormat.cultureCode,"precision":_vm.moneyFormat.numberOfDecimal},model:{value:(_vm.model.hourlyRate),callback:function ($$v) {_vm.$set(_vm.model, "hourlyRate", $$v)},expression:"model.hourlyRate"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.hourlyRate.minValue)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Min hourly rate is 0")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Percentage Charge")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.percentageCharge),expression:"model.percentageCharge"}],staticClass:"form-control",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.percentageCharge.$error,
                          },attrs:{"type":"number","step":"any"},domProps:{"value":(_vm.model.percentageCharge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "percentageCharge", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.percentageCharge.minValue)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Min percentage is 0")]):_vm._e()]),_vm._v(" "),(_vm.isAllowToCreate || _vm.isAllowToUpdate)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.reset()}}},[_vm._v("\n                          Reset\n                        ")]),_vm._v(" "),(!_vm.isUpdate && _vm.isAllowToCreate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                          Create\n                        ")]):_vm._e(),_vm._v(" "),(_vm.isUpdate && _vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                          Update\n                        ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 divider-left pl-20"},[_c('div',{staticClass:"table-modal-detail"},[_c('div',{staticClass:"table-responsive table-accordion"},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',{staticClass:"number"},[_vm._v("No")]),_vm._v(" "),_c('th',[_vm._v("Peak Period")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("\n                                  Flat Rate\n                                  "),(_vm.moneyFormat)?_c('span',{staticClass:"--grey50"},[_vm._v("\n                                    ("+_vm._s(_vm.moneyFormat.currencyCode)+")\n                                  ")]):_vm._e()]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("\n                                  Hourly Rate\n                                  "),(_vm.moneyFormat)?_c('span',{staticClass:"--grey50"},[_vm._v("\n                                    ("+_vm._s(_vm.moneyFormat.currencyCode)+")\n                                  ")]):_vm._e()]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Percentage")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{key:item.id},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.peakPeriod.title))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                                  "+_vm._s(_vm.printMoney(item.flatRate))+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                                  "+_vm._s(_vm.printMoney(item.hourlyRate))+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(item.percentageCharge))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isActive),expression:"item.isActive"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":!_vm.isAllowToUpdate},domProps:{"checked":Array.isArray(item.isActive)?_vm._i(item.isActive,null)>-1:(item.isActive)},on:{"change":[function($event){var $$a=item.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isActive", $$c)}},function($event){return _vm.changeStatus(item)}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                                      "+_vm._s(item.isActive ? "Active" : "Inactive")+"\n                                    ")])])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(_vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.bindModel(item)}}},[_c('span',[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToDelete)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id)}}},[_c('i',{staticClass:"ic-close"})]):_vm._e()])])])}),0)])])])])])])])])])])])])]),_vm._v(" "),_c('deleteModal',{on:{"submit":_vm.submitDelete}}),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 973:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverriddenWaitingTimeSurcharge_vue__ = __webpack_require__(737);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcea8422_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverriddenWaitingTimeSurcharge_vue__ = __webpack_require__(975);
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverriddenWaitingTimeSurcharge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcea8422_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverriddenWaitingTimeSurcharge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 974:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/buying/override/WaitingTimeSurcharges';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(policyId) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list/' + policyId)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  create: function create(request) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  update: function update(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  delete: function _delete(id) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 975:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedPolicy && _vm.isOpen)?_c('div',[_c('div',{ref:"vuemodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-new",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Waiting Time ("+_vm._s(_vm.selectedPolicy.policyTitle)+")")]),_vm._v(" "),_c('h6',[_vm._v("\n                Last Updated: "+_vm._s(_vm.model.modifiedDate ? _vm.model.modifiedDate.stringFullDate : '-')+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.closeModal()}}},[_c('i',{staticClass:"ic-close"})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper modal-detail"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[(_vm.$v.model.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                  This form has errors\n                ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 divider-right pr-25"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Source Type")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                            'field-error': _vm.isSubmitted && _vm.$v.model.type.$error,
                          },attrs:{"placeholder":"","label":"text","options":_vm.sourceTypes,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},model:{value:(_vm.model.type),callback:function ($$v) {_vm.$set(_vm.model, "type", $$v)},expression:"model.type"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.type.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Type is required")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.totalMinuteAllowed),expression:"model.totalMinuteAllowed"}],staticClass:"form-control",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.totalMinuteAllowed.$error,
                          },attrs:{"type":"number","placeholder":"Number"},domProps:{"value":(_vm.model.totalMinuteAllowed)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "totalMinuteAllowed", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.totalMinuteAllowed.$error)?_c('div',[(!_vm.$v.model.totalMinuteAllowed.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Total Minutes is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.totalMinuteAllowed.minValue)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Min total minutes is\n                            "+_vm._s(_vm.$v.model.totalMinuteAllowed.$params.minValue.min))]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("\n                          Rate\n                          "),(_vm.moneyFormat)?_c('span',{staticClass:"--grey50"},[_vm._v("("+_vm._s(_vm.moneyFormat.currencyCode)+")")]):_vm._e()]),_vm._v(" "),_c('currency-input',{staticClass:"form-control",class:{
                            'field-error': _vm.isSubmitted && _vm.$v.model.rate.$error,
                          },attrs:{"autocomplete":"off","placeholder":"Enter rate","allow-negative":false,"currency":null,"locale":_vm.moneyFormat.cultureCode,"precision":_vm.moneyFormat.numberOfDecimal},model:{value:(_vm.model.rate),callback:function ($$v) {_vm.$set(_vm.model, "rate", $$v)},expression:"model.rate"}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.rate.$error)?_c('div',[(!_vm.$v.model.rate.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Rate is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.rate.minValue)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Min rate is "+_vm._s(_vm.$v.model.rate.$params.minValue.min))]):_vm._e()]):_vm._e()],1),_vm._v(" "),(_vm.isAllowToCreate || _vm.isAllowToUpdate)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.reset()}}},[_vm._v("\n                          Reset\n                        ")]),_vm._v(" "),(!_vm.isUpdate && _vm.isAllowToCreate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                          Create\n                        ")]):_vm._e(),_vm._v(" "),(_vm.isUpdate && _vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                          Update\n                        ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 divider-left pl-20"},[_c('div',{staticClass:"table-modal-detail"},[_c('div',{staticClass:"table-responsive table-accordion"},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',{staticClass:"number"},[_vm._v("No")]),_vm._v(" "),_c('th',[_vm._v("Source")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Allowed Time (minute)")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("\n                                  Rate\n                                  "),(_vm.moneyFormat)?_c('span',{staticClass:"--grey50"},[_vm._v("\n                                    ("+_vm._s(_vm.moneyFormat.currencyCode)+")\n                                  ")]):_vm._e()]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{key:item.id},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.humanize(item.type)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                                  "+_vm._s(item.totalMinuteAllowed)+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.printMoney(item.rate)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isActive),expression:"item.isActive"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":!_vm.isAllowToUpdate},domProps:{"checked":Array.isArray(item.isActive)?_vm._i(item.isActive,null)>-1:(item.isActive)},on:{"change":[function($event){var $$a=item.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isActive", $$c)}},function($event){return _vm.changeStatus(item)}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                                      "+_vm._s(item.isActive ? "Active" : "Inactive")+"\n                                    ")])])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(_vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.bindModel(item)}}},[_c('span',[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToDelete)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id)}}},[_c('i',{staticClass:"ic-close"})]):_vm._e()])])])}),0)])])])])])])])])])])])])]),_vm._v(" "),_c('deleteModal',{on:{"submit":_vm.submitDelete}}),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"required"},[_vm._v("\n                          Allowed Time\n                          "),_c('span',{staticClass:"--grey50"},[_vm._v("(minute)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 976:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/buying/override/Surcharges';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list' + filter).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 977:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"middle-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter"},[_c('i',{staticClass:"ic-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.keyword),expression:"table.keyword"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"Search"},domProps:{"value":(_vm.table.keyword)},on:{"keyup":function($event){return _vm.onKeyupKeyword()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.table, "keyword", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length pull-right"},[_c('label',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.pageSize),expression:"table.pageSize"}],staticClass:"form-control v-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.table, "pageSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onChangePageSize()}]}},_vm._l((_vm.table.pageSizes),function(item){return _c('option',{key:item,domProps:{"value":item}},[_vm._v("\n                  "+_vm._s(item)+"\n                ")])}),0),_vm._v("\n              Entries\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive table-p15"},[_c('table',{staticClass:"table table-hover"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.id,staticClass:"detail-row"},[_c('td',[_vm._v(_vm._s(item.policyTitle))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.providerName))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(_vm.isAllowToManageGeneralSurcharge)?_c('button',{staticClass:"btn btn-default --green35",attrs:{"type":"button"},on:{"click":function($event){return _vm.manageGeneralSurcharge(item)}}},[_c('span',[_vm._v("General")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToManageCancellationSurcharge)?_c('button',{staticClass:"btn btn-default --green35",attrs:{"type":"button"},on:{"click":function($event){return _vm.manageCancellationSurcharge(item)}}},[_c('span',[_vm._v("Cancellation")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToManagePeakPeriodSurcharge)?_c('button',{staticClass:"btn btn-default --green35",attrs:{"type":"button"},on:{"click":function($event){return _vm.managePeakPeriodSurcharge(item)}}},[_c('span',[_vm._v("Peak-Period")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToManageWaitingTimeSurcharge)?_c('button',{staticClass:"btn btn-default --green35",attrs:{"type":"button"},on:{"click":function($event){return _vm.manageWaitingTimeSurcharge(item)}}},[_c('span',[_vm._v("Waiting-Time")])]):_vm._e()])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"dataTables_info --blue25"},[_c('strong',[_vm._v(_vm._s(_vm.recordInfo))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('nav',{attrs:{"aria-label":"..."}},[_c('paginate',{attrs:{"page-count":_vm.table.totalPages,"click-handler":_vm.onNavigateCallback,"prev-text":'Previous',"next-text":'Next',"container-class":'pagination pull-right'},model:{value:(_vm.table.pageNumber),callback:function ($$v) {_vm.$set(_vm.table, "pageNumber", $$v)},expression:"table.pageNumber"}})],1)])])])]),_vm._v(" "),(_vm.isAllowToManageGeneralSurcharge)?_c('generalSurcharge'):_vm._e(),_vm._v(" "),(_vm.isAllowToManageCancellationSurcharge)?_c('cancellationSurcharge'):_vm._e(),_vm._v(" "),(_vm.isAllowToManagePeakPeriodSurcharge)?_c('peakPeriodSurcharge'):_vm._e(),_vm._v(" "),(_vm.isAllowToManageWaitingTimeSurcharge)?_c('waitingTimeSurcharge'):_vm._e(),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-header-info"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb"},[_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Operator Tariff")])]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("\n                Surcharge (Overrides)\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"content-header-info"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"pull-left"},[_c('h2',[_vm._v("\n                  Surcharges (Overrides) "),_c('span',[_c('i',{staticClass:"ic-price-calculator"})])]),_vm._v(" "),_c('p',[_vm._v("Set surcharge for Operator Tariff.")])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Policy")]),_vm._v(" "),_c('th',[_vm._v("Provider")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/12.580e2150da28f954b2b5.js